import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";

const CNPhuluc9 = React.memo(function CNPhuluc9(props) {
  const { baocao_id } = props;
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [sogiaycndkkd, setSogiaycndkkd] = React.useState("");
  const [ten, setTen] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [dienthoai, setDienthoai] = React.useState("");
  const [ngay_giaithe, setNgay_giaithe] = React.useState(null);
  const [ngay_ngunghoatdong, setNgay_ngunghoatdong] = React.useState(null);
  const [ngay_thuhoi_giaycndkkd, setNgay_thuhoi_giaycndkkd] = React.useState(
    null
  );
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/BaoCao/getslpl09theoid?id=" +
      baocao_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) {
          if (data[0].sogiaycndkkd) setSogiaycndkkd(data[0].sogiaycndkkd);
          if (data[0].ten) setTen(data[0].ten);
          if (data[0].diachi) setDiachi(data[0].diachi);
          if (data[0].dienthoai) setDienthoai(data[0].dienthoai);
          if (data[0].ghichu) setGhichu(data[0].ghichu);
          let [month, year] = data[0].thang.split("/");
          setThangnam(dayjs(year + "-" + month));
          if (data[0].ngay_giaithe !== "N/A") {
            let [year, month, day] = data[0].ngay_giaithe.split("-");
            setNgay_giaithe(dayjs(year + "/" + month + "/" + day));
          }
          if (data[0].ngay_ngunghoatdong !== "N/A") {
            let [year1, month1, day1] = data[0].ngay_ngunghoatdong.split("-");
            setNgay_ngunghoatdong(dayjs(year1 + "/" + month1 + "/" + day1));
          }
          if (data[0].ngay_thuhoi_giaycndkkd !== "N/A") {
            let [year2, month2, day2] = data[0].ngay_thuhoi_giaycndkkd.split(
              "-"
            );
            setNgay_thuhoi_giaycndkkd(dayjs(year2 + "/" + month2 + "/" + day2));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var thangbc = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var ngaygt = null;
    if (ngay_giaithe) {
      ngaygt =
        ngay_giaithe.$y +
        "-" +
        String(ngay_giaithe.$M + 1).padStart(2, "0") +
        "-" +
        ngay_giaithe.$D;
    }
    var ngaynhd = null;
    if (ngay_ngunghoatdong) {
      ngaynhd =
        ngay_ngunghoatdong.$y +
        "-" +
        String(ngay_ngunghoatdong.$M + 1).padStart(2, "0") +
        "-" +
        ngay_ngunghoatdong.$D;
    }
    var ngayth = null;
    if (ngay_thuhoi_giaycndkkd) {
      ngayth =
        ngay_thuhoi_giaycndkkd.$y +
        "-" +
        String(ngay_thuhoi_giaycndkkd.$M + 1).padStart(2, "0") +
        "-" +
        ngay_thuhoi_giaycndkkd.$D;
    }
    var url = Config.backend + "/api/BaoCao/capnhatslpl09";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: baocao_id,
        thang: thangbc,
        sogiaycndkkd: sogiaycndkkd,
        ten: ten,
        diachi: diachi,
        dienthoai: dienthoai,
        ngay_giaithe: ngaygt,
        ngay_ngunghoatdong: ngaynhd,
        ngay_thuhoi_giaycndkkd: ngayth,
        ghichu: ghichu,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === "1") {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => {
                    setDisableBT(false);
                    setThangnam(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số giấy chứng nhận ĐKKD"
                variant="outlined"
                size="small"
                value={sogiaycndkkd}
                onChange={(event) => {
                  setSogiaycndkkd(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Tên hợp tác xã, hộ cá thể"
                variant="outlined"
                size="small"
                value={ten}
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Điện thoại"
                variant="outlined"
                size="small"
                value={dienthoai}
                onChange={(event) => {
                  setDienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày giải thể"
                  value={ngay_giaithe}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgay_giaithe(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày ngưng hoạt động"
                  value={ngay_ngunghoatdong}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgay_ngunghoatdong(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày thu hồi giấy CN ĐKKD"
                  value={ngay_thuhoi_giaycndkkd}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgay_thuhoi_giaycndkkd(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Ghi chú báo cáo"
                variant="outlined"
                size="small"
                value={ghichu}
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

CNPhuluc9.propTypes = {
  baocao_id: PropTypes.number,
};
export default CNPhuluc9;
